import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select"];

  handleSortChange(event) {
    const selectedValue = event.target.value;

    // Track analytics event
    window.trackEvent("Changed Sort", {
      sortBy: selectedValue,
      userId: this.data.get('currentUser') || 'Visitors',
      source: 'Marketplace'
    });

    // Build URL with current parameters
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set(this.data.get('paramName'), selectedValue);

    // Redirect to new URL
    window.location.href = currentUrl.toString();
  }
}
